import { formatCurrency } from "../../utils/formatCurrency";

export default function KpiCard({ title, value, loading }) {
    return (
        <div className="kpi-card">
            <div className="kpi-title">{title}</div>
            <div className="kpi-value">{loading ? "..." : formatCurrency(value || 0)}</div>
        </div>
    );
}